<script>
export default {
  name: "app-header",
  computed: {
    loggedIn() {
      return this.$store.getters["authentication/loggedIn"];
    },
    user() {
      return this.$store.getters["authentication/user"];
    },
    newNotificationsCount() {
      return this.$store.getters["notifications/newEntries"].length;
    },
    useTokens() {
      return this.user.hasOwnProperty("tokens");
    }
  },
  methods: {
    toggle() {
      this.$store.dispatch("notifications/togglePanel");
    },
    logout() {
      this.$store.dispatch("authentication/logout");
    }
  }
};
</script>

<template>
  <header id="sapp__header">
    <div class="wrapper">
      <router-link :to="{ name: 'finder' }" id="sapp_branding"
        >Solicitapp</router-link
      >

      <div id="sapp_toolbar" v-if="loggedIn">
        <div class="toolbar-container">
          <div class="toolbar-item finder">
            <router-link :to="{ name: 'finder' }" class="tool-link">
              <span class="link-wrap">
                <i class="sappfont sappfont-financiapp is-size-4"></i>
                <span class="text">Aplicaciones</span>
              </span>
            </router-link>
          </div>
          <div v-if="useTokens" class="toolbar-item tokens">
            <router-link :to="{ name: 'tokens' }" class="tool-link">
              <span class="link-wrap">
                <i class="sappfont sappfont-credit is-size-4"></i>
                <span class="tokensCount">{{ user.tokens | formatMoney }}</span>
                <span
                  class="tokensString"
                  v-html="user.tokens > 1 ? ' Créditos' : ' Crédito'"
                ></span>
              </span>
            </router-link>
          </div>
          <div v-if="!useTokens" class="toolbar-item publish">
            <router-link :to="{ name: 'publish' }" class="tool-link">
              <span class="link-wrap">
                <i class="sappfont sappfont-add is-size-4"></i>
                <span class="text">Crear Applicación</span>
              </span>
            </router-link>
          </div>
          <div class="toolbar-item notifications">
            <a @click.prevent.stop="toggle" class="tool-link">
              <div class="link-wrap">
                <i class="sappfont sappfont-bell is-size-4"></i
                ><span class="count">{{ newNotificationsCount }}</span>
              </div>
            </a>
          </div>
          <b-dropdown position="is-bottom-left" class="toolbar-item account">
            <a :to="{ name: 'account' }" slot="trigger" class="tool-link">
              <div class="link-wrap">
                <i class="sappfont sappfont-user is-size-4"></i
                ><span class="text"
                  >{{ user.display_name }}
                  <i class="sappfont sappfont-angle-down"></i
                ></span>
              </div>
            </a>
            <b-dropdown-item has-link class="area-user">
              <router-link :to="{ name: 'account' }">
                <span class="data name">{{ user.display_name }}</span>
                <span class="data email">{{ user.username }}</span>
              </router-link>
            </b-dropdown-item>
            <hr class="dropdown-divider" />
            <b-dropdown-item has-link
              ><router-link to="/test/">Test</router-link></b-dropdown-item
            >
            <b-dropdown-item has-link
              ><router-link to="/settings/"
                >Settings</router-link
              ></b-dropdown-item
            >
            <hr class="dropdown-divider" />
            <b-dropdown-item has-link
              ><a href="#" @click.prevent="logout">Logout</a></b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
#sapp__header {
  position: fixed;
  height: 4rem;
  width: 100%;
  z-index: 10;
  background-color: #fff;
  // background-color: #32067c;
  .toolbar-container {
    display: flex;
    align-items: center;
    .tool-link {
      display: block;
      // color: #fff;
      color: #4d5786;
      font-weight: 500;
      padding: 0.75rem;
      .link-wrap {
        position: relative;
        display: flex;
        align-items: center;
        > i {
          text-align: center;
          font-size: 1.5rem;
          width: 1em;
        }
      }
    }
    .finder .link-wrap .text,
    .account .link-wrap .text {
      margin-left: 0.5rem;
    }
    .publish .text {
      margin-left: 0.5rem;
    }
    .tokensString {
      margin-left: 0.25rem;
    }
    .notifications .count {
      color: #fff;
      background-color: red;
      display: inline-block;
      width: 1.125rem;
      height: 1.125rem;
      line-height: 1.125rem;
      text-align: center;
      border-radius: 50%;
      font-size: 0.5625rem;
      font-weight: bold;
      position: absolute;
      top: -3px;
      right: -7px;
    }
  }
  .area-user {
    .data {
      display: block;
    }
    .name {
      font-weight: bold;
    }
    .email {
      font-size: 0.75rem;
    }
  }
}

@media only screen and (max-width: 39.9375em) {
  #sapp__header {
    display: flex;
    align-items: center;
    bottom: 0;
    padding: 0 1rem;
    border-top: 1px solid #f6f9ff;
    height: calc(4rem + env(safe-area-inset-bottom, 0rem));
    padding-bottom: calc(env(safe-area-inset-bottom, 0rem));
    // @supports (padding: Max(0px)) {
    //   padding-bottom: Max(0.5rem, calc(env(safe-area-inset-bottom) + 0.5rem));
    // }
    .wrapper {
      width: 100%;
    }
    #sapp_branding {
      display: none;
    }
    #sapp_toolbar {
      .toolbar-container {
        justify-content: space-around;
        .tool-link {
          color: #58437c;
          color: #061387;
          color: #4d5786;
        }
        .tool-link .text,
        .tokensString {
          display: none;
        }
      }
    }
  }
}
@media only screen and (min-width: 40em) {
  #sapp__header {
    top: 0;
    padding: 0.5rem 0;
    // border-bottom: 1px solid #f6f9ff;
    background-color: $primary;
    > .wrapper {
      display: flex;
      position: relative;
      align-items: center;
      justify-content: space-between;
    }
    #sapp_branding {
      color: #fff;
    }
    .toolbar-container {
      .tool-link {
        color: #fff;
      }
    }
  }
  #sapp_branding {
    display: block;
    font-size: 1.25rem;
    font-weight: bold;
    padding-left: 1rem;
  }
  #sapp_toolbar {
    display: flex;
    justify-content: flex-end;
    user-select: none;
  }
  // .toolbar-item {
  //   border-left: 1px solid #ecf1f4;
  // }
}

@media (min-width: 783px) {
  body.admin-bar #sapp__header {
    padding-top: 32px;
  }
}
</style>
